// extracted by mini-css-extract-plugin
export default {"firstblock":"Dashboard_firstblock__4HkLs","h3":"Dashboard_h3__zdP1p","main":"Dashboard_main__ZVW6C","taskcard":"Dashboard_taskcard__6ZR0f"};